import { compose, contains, filter, getOr, lowerCase } from 'lodash/fp'
import { IRoom } from '../../../models/Room'

export default function filterByName<T extends FilteredRoom>(
  appliedFilter: IFilter,
) {
  const filteredName = compose<unknown[], string, string>(
    lowerCase,
    getOr('', 'name'),
  )(appliedFilter)

  return filter<T>(
    compose(
      contains(filteredName),
      lowerCase,
      getOr('', 'name'),
    ),
  )
}

interface IFilter {
  name?: string
}

type FilteredRoom = Pick<Partial<IRoom>, 'name'>
